import { render, staticRenderFns } from "./ModalUpdateFontStyle.vue?vue&type=template&id=9d5dd69e&"
import script from "./ModalUpdateFontStyle.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateFontStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports